export default __webpack_public_path__ + "static/durss_artifact-30cb9c7bea18429533f05c5f2a63ea54.jpg";